import { render, staticRenderFns } from "./DeleteReport.vue?vue&type=template&id=d84bffc4&scoped=true"
import script from "./DeleteReport.vue?vue&type=script&lang=js"
export * from "./DeleteReport.vue?vue&type=script&lang=js"
import style0 from "./DeleteReport.vue?vue&type=style&index=0&id=d84bffc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84bffc4",
  null
  
)

export default component.exports